export default {
  success(request) {
    const success = request.status === 200
    return success
  },
}
